<template>
  <div class="c-app" style="background-color: #F7F0E6" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <TheSidebar/>
    <CWrapper>
      <TheHeader @updateEventCode="updateEventCode" @updateEventPlanner="updateEventPlanner"/>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade" mode="out-in">
              <router-view :key="$route.path"></router-view>
            </transition>
          </CContainer>
        </main>
      </div>
      <TheFooter/>
    </CWrapper>
    <loading :active="visible" :can-cancel="true" loader="bars"></loading>
    <CToaster placement="top-end">
      <template v-for="(toast, key) in toasts">
        <CToast :color="toast.color" v-bind="toast" :key="'toast' + key" :show="true">
          {{toast.content}}
        </CToast>
      </template>
    </CToaster>
    <EventCodeModal ref="eventCodeModal"></EventCodeModal>
    <EventPlannerModal ref="eventPlannerModal"></EventPlannerModal>    
  </div>
</template>
<script>
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'
import EventCodeModal from '../components/configuration/EventCodeModal.vue';
import EventPlannerModal from '../components/configuration/EventPlannerModal.vue';
import store from '../store'
import Vue from 'vue';
import Loading from 'vue-loading-overlay/dist/vue-loading.js';
import 'vue-loading-overlay/dist/vue-loading.css';
import ws from '../services/general';

export default {
  name: 'TheContainer',
  components: {
    TheSidebar,
    TheHeader,
    TheFooter,
    Loading,
    EventCodeModal,
    EventPlannerModal,
  },
  data() {
      return {        
      }
  },
  mounted: async function() {
  }, 
  computed: {
    toasts () {
      return store.state.toasts;
    },
    visible() {
      return store.state.isLoading;
    }
  },
  methods: {
    updateEventCode () {
      this.$refs.eventCodeModal.updateModal();
    },
    updateEventPlanner () {
      this.$refs.eventPlannerModal.updateModal();
    },    
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
